module.exports = __webpack_public_path__ + "img/C2A584_363B41_71665B_8C7367-256px.44737e04.png";